<template>
  <div id="app">
    <router-view target="_blank" />
  </div>
</template>
<script>

import { getInsNameByDomainName } from '@/utils/auth';

  export default {
    name: 'App',
    data(){
        return{

        }
    },
    created(){
      // var title='乐庭智慧云'
      // let host=window.location.host
      // if(host=='yian.visual.ltylao.com'){
      //   title = '来凤颐安智慧云'
      // }
      document.title=getInsNameByDomainName()+'智慧云';
    },
  }
</script>
<style>
  html,body{padding: 0px;margin: 0px;height: 100%;}
  #app{height: 100%;}
</style>
